/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationSuggestionResponse
 */
export interface OrganizationSuggestionResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationSuggestionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSuggestionResponse
     */
    name: string;
}

/**
 * Check if a given object implements the OrganizationSuggestionResponse interface.
 */
export function instanceOfOrganizationSuggestionResponse(value: object): value is OrganizationSuggestionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OrganizationSuggestionResponseFromJSON(json: any): OrganizationSuggestionResponse {
    return OrganizationSuggestionResponseFromJSONTyped(json, false);
}

export function OrganizationSuggestionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSuggestionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OrganizationSuggestionResponseToJSON(value?: OrganizationSuggestionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

